/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useCallback } from "react";
import { TABATA_EX_BASE } from './exercises.js';
import { ExPicker } from './HomePage.js';

// ─── CONSTANTES ───────────────────────────────────────────────────────────────
const LS_TABATA_KEY = "bearforge_tabata_state";

const INTERVALS = [
  {id:"20-10",label:"20-10s",work:20,rest:10},
  {id:"30-30",label:"30-30s",work:30,rest:30},
  {id:"40-20",label:"40-20s",work:40,rest:20},
  {id:"45-15",label:"45-15s",work:45,rest:15},
  {id:"50-10",label:"50-10s",work:50,rest:10},
  {id:"custom",label:"Personnalisé",work:30,rest:15},
];

const showToast = (message, type = "info") => {
  const toast = document.createElement("div");
  toast.textContent = message;
  toast.style.cssText = `position:fixed;bottom:100px;left:50%;transform:translateX(-50%);background:${type==="error"?"#ef4444":"#3b82f6"};color:white;padding:10px 20px;border-radius:12px;font-weight:700;font-size:14px;z-index:9999;pointer-events:none;`;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 3000);
};

// ─── UTILS AUDIO ─────────────────────────────────────────────────────────────
let _ctx = null;
const getCtx = () => {
  if (!_ctx || _ctx.state === "closed") _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === "suspended") _ctx.resume();
  return _ctx;
};
const beep = (freq, dur, vol=0.4, type="sine") => {
  try {
    const c = getCtx(); const o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination); o.frequency.value = freq; o.type = type;
    const t = c.currentTime;
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.001, t+dur);
    o.start(t); o.stop(t+dur+0.01);
  } catch(e) {}
};
const duckAudio = (duck) => {
  try {
    if ('mediaSession' in navigator) navigator.mediaSession.playbackState = duck ? 'playing' : 'paused';
  } catch(e) {}
};
const playFinish = () => {
  try {
    duckAudio(true);
    const c = getCtx();
    const o = c.createOscillator(), g = c.createGain();
    o.connect(g); g.connect(c.destination);
    o.frequency.value = 880; o.type = "sine";
    const t = c.currentTime;
    g.gain.setValueAtTime(0.7, t);
    g.gain.setValueAtTime(0.7, t+1.5);
    g.gain.exponentialRampToValueAtTime(0.001, t+2.2);
    o.start(t); o.stop(t+2.3);
    setTimeout(() => duckAudio(false), 2300);
  } catch(e) {}
};
const speak = t => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(t);
  u.lang = "fr-FR"; u.rate = 0.95;
  window.speechSynthesis.speak(u);
};

// ─── UI ATOMS ─────────────────────────────────────────────────────────────────
const Tag = ({label,color,bg}) => (
  <span style={{background:bg,color,fontSize:11,padding:"3px 10px",borderRadius:20,fontWeight:700}}>{label}</span>
);
const MM = {
  "Pectoraux":{color:"#ef4444",bg:"rgba(239,68,68,0.12)"},
  "Dos":{color:"#8b5cf6",bg:"rgba(139,92,246,0.12)"},
  "Épaules":{color:"#eab308",bg:"rgba(234,179,8,0.12)"},
  "Biceps":             {color:"#f97316",bg:"rgba(249,115,22,0.12)"},
  "Triceps":            {color:"#06b6d4",bg:"rgba(6,182,212,0.12)"},
  "Quadriceps":         {color:"#3b82f6",bg:"rgba(59,130,246,0.12)"},
  "Ischio-jambiers":    {color:"#10b981",bg:"rgba(16,185,129,0.12)"},
  "Fessiers":           {color:"#ec4899",bg:"rgba(236,72,153,0.12)"},
  "Mollets":            {color:"#14b8a6",bg:"rgba(20,184,166,0.12)"},
  "Abdominaux":         {color:"#f59e0b",bg:"rgba(245,158,11,0.12)"},
  "Trapèzes":           {color:"#a78bfa",bg:"rgba(167,139,250,0.12)"},
  "Avant-bras":         {color:"#fb923c",bg:"rgba(251,146,60,0.12)"},
  "Cardio / Full body": {color:"#84cc16",bg:"rgba(132,204,22,0.12)"},
};
const mkBtn = C => ({children,onClick,variant="primary",small,full,disabled,style:s={}}) => {
  const v = {
    primary:{background:`linear-gradient(135deg,${C.accent},${C.accent2})`,color:"white",boxShadow:`0 4px 20px ${C.glow}`},
    ghost:  {background:C.faint,color:C.muted,border:`1px solid ${C.border}`},
    outline:{background:"transparent",color:C.accent,border:`1px solid ${C.accent}`},
    danger: {background:"rgba(239,68,68,0.1)",color:C.red,border:"1px solid rgba(239,68,68,0.25)"},
  };
  return <button onClick={disabled?undefined:onClick} style={{border:"none",fontWeight:800,borderRadius:12,cursor:disabled?"default":"pointer",opacity:disabled?0.35:1,fontSize:small?13:15,letterSpacing:0.4,padding:small?"8px 16px":"14px 20px",width:full?"100%":undefined,transition:"all 0.15s",...v[variant],...s}}>{children}</button>;
};
const ConfirmModal = ({message,onConfirm,onCancel,confirmLabel,cancelLabel,C}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:"0 24px"}}>
    <div style={{background:C.card,borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:380,border:`1px solid ${C.border}`}}>
      <p style={{color:C.text,fontWeight:800,fontSize:17,margin:"0 0 8px",textAlign:"center"}}>Confirmer</p>
      <p style={{color:C.muted,fontSize:14,margin:"0 0 24px",textAlign:"center",lineHeight:1.5}}>{message}</p>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <button onClick={onCancel} style={{padding:"12px",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.muted,fontWeight:800,cursor:"pointer"}}>{cancelLabel||"Annuler"}</button>
        <button onClick={onConfirm} style={{padding:"12px",background:confirmLabel?"rgba(59,130,246,0.12)":"rgba(239,68,68,0.12)",border:confirmLabel?"1px solid rgba(59,130,246,0.3)":"1px solid rgba(239,68,68,0.3)",borderRadius:12,color:confirmLabel?C.accent:C.red,fontWeight:800,cursor:"pointer"}}>{confirmLabel||"Supprimer"}</button>
      </div>
    </div>
  </div>
);

function TabataRunPage({program,onFinish,onSaveSession,C}) {
  const [phase,setPhase]=useState("prepare");
  const [t,setT]=useState(10);
  const [round,setRound]=useState(0);
  const [exI,setExI]=useState(0);
  const [paused,setPaused]=useState(false);
  const [startTime]=useState(Date.now()); // Track start time
  const fired=useRef(false);
  const tabLastTick=useRef(-1);
  const phaseRef=useRef("prepare");
  const tRef=useRef(10);
  const pausedRef=useRef(false);
  const intervalRef=useRef(null);
  const exIRef=useRef(0);
  const roundRef=useRef(0);
  const phaseEndRef=useRef(null); // Timestamp de fin de phase courante
  const rewindResetRef=useRef(null); // Timestamp du dernier reset via bouton retour
  const {exercises,rounds,interval,customWork,customRest}=program;
  const intvl=interval==="custom"
    ?{work:customWork||30,rest:customRest||15}
    :INTERVALS.find(i=>i.id===interval)||INTERVALS[0];
  const totalEx=exercises.length;

  const advance=useCallback((curExI,curRound)=>{
    // Bloquer immédiatement tout re-déclenchement pendant la transition
    phaseEndRef.current=Date.now()+60000; // verrou temporaire
    fired.current=false;
    const ph=phaseRef.current;
    const setPhaseEnd=(sec)=>{phaseEndRef.current=Date.now()+sec*1000;};
    if(ph==="prepare"){
      phaseRef.current="work";setPhase("work");setExI(0);setRound(0);
      tRef.current=intvl.work;setT(intvl.work);setPhaseEnd(intvl.work);
      speak(exercises[0]?.name||"Go");
    } else if(ph==="work"){
      // Check si c'est le dernier exercice du dernier round
      const isLastExInRound = curExI === totalEx - 1;
      const isLastRound = curRound === rounds - 1;
      
      if(isLastExInRound && isLastRound){
        // Dernier exo du dernier round : skip repos, terminer directement
        phaseRef.current="done";setPhase("done");
        try{localStorage.removeItem(LS_TABATA_KEY);}catch{}
        playFinish();speak("Tabata terminé ! Bien joué !");
        if(onSaveSession){
          const duration = Math.floor((Date.now()-startTime)/60000); // durée en minutes
          onSaveSession({id:Date.now(),type:"tabata",programName:program.name,date:new Date().toISOString(),rounds,totalEx,interval:intvl.label,duration,exercises:exercises.map(e=>({id:e.id,name:e.name,muscle:e.muscle}))});
        }
      } else {
        // Sinon, repos normal
        phaseRef.current="rest";setPhase("rest");
        tRef.current=intvl.rest;setT(intvl.rest);setPhaseEnd(intvl.rest);
        speak("Repos");
      }
    } else if(ph==="rest"){
      const nextExI=curExI+1;
      if(nextExI<totalEx){
        phaseRef.current="work";setPhase("work");setExI(nextExI);
        tRef.current=intvl.work;setT(intvl.work);setPhaseEnd(intvl.work);
        speak(exercises[nextExI]?.name||"Go");
      } else {
        const nextRound=curRound+1;
        if(nextRound<rounds){
          phaseRef.current="work";setPhase("work");setExI(0);setRound(nextRound);
          tRef.current=intvl.work;setT(intvl.work);setPhaseEnd(intvl.work);
          speak(`Round ${nextRound+1}. ${exercises[0]?.name}`);
        } else {
          phaseRef.current="done";setPhase("done");
          try{localStorage.removeItem(LS_TABATA_KEY);}catch{}
          playFinish();speak("Tabata terminé ! Bien joué !");
          if(onSaveSession){
            const duration = Math.floor((Date.now()-startTime)/60000);
            onSaveSession({id:Date.now(),type:"tabata",programName:program.name,date:new Date().toISOString(),rounds,totalEx,interval:intvl.label,duration,exercises:exercises.map(e=>({id:e.id,name:e.name,muscle:e.muscle}))});
          }
        }
      }
    }
  },[intvl,exercises,totalEx,rounds,onSaveSession,program.name,startTime]);

  useEffect(()=>{exIRef.current=exI;},[exI]);
  useEffect(()=>{roundRef.current=round;},[round]);

  // Persister l'état Tabata dans localStorage
  const persistTabata=()=>{
    if(phaseRef.current==="done")return;
    try{localStorage.setItem(LS_TABATA_KEY,JSON.stringify({
      programId:program.id,
      phase:phaseRef.current,
      phaseEnd:phaseEndRef.current,
      round:roundRef.current,
      exI:exIRef.current,
      paused:pausedRef.current,
    }));}catch{}
  };

  const tabataWakeLockRef=useRef(null);
  useEffect(()=>{
    try{getCtx();}catch(e){}
    speak("Prépare-toi !");
    const acquireWL=async()=>{try{if("wakeLock" in navigator){tabataWakeLockRef.current=await navigator.wakeLock.request("screen");}}catch(e){}};
    acquireWL();
    const onVis=()=>{
      if(document.visibilityState==="visible"){
        acquireWL();
        // Recalculer le temps restant au retour au premier plan
        if(phaseEndRef.current&&!pausedRef.current){
          const remaining=Math.max(0,Math.round((phaseEndRef.current-Date.now())/1000));
          tRef.current=remaining;
          setT(remaining);
        }
      } else {
        persistTabata();
      }
    };
    document.addEventListener("visibilitychange",onVis);
    if(intervalRef.current)clearInterval(intervalRef.current);
    // Initialiser phaseEnd pour la phase prepare (10s)
    phaseEndRef.current=Date.now()+10000;
    intervalRef.current=setInterval(()=>{
      if(pausedRef.current)return;
      const remaining=Math.max(0,Math.round((phaseEndRef.current-Date.now())/1000));
      tRef.current=remaining;
      setT(remaining);
      if(remaining>=1&&remaining<=3&&remaining!==tabLastTick.current){
        tabLastTick.current=remaining;
        beep(600,0.12,0.6,"square");
      }
      if(remaining===0&&!fired.current){
        fired.current=true;
        tabLastTick.current=-1;
        beep(600,1.5,0.6,"square");
        if(phaseRef.current!=="done"){setTimeout(()=>advance(exIRef.current,roundRef.current),400);}
      }
    },250);
    return()=>{if(intervalRef.current)clearInterval(intervalRef.current);document.removeEventListener("visibilitychange",onVis);tabataWakeLockRef.current?.release();tabataWakeLockRef.current=null;try{localStorage.removeItem(LS_TABATA_KEY);}catch{}};
  },[advance]);

  const togglePause=()=>{
    const np=!paused;setPaused(np);pausedRef.current=np;
    if(!np){
      // Au resume, recaler phaseEndRef pour le temps restant
      phaseEndRef.current=Date.now()+tRef.current*1000;
      speak(phase==="work"?(exercises[exI]?.name||"Go"):phase==="rest"?"Repos":"Prépare-toi !");
    } else {
      persistTabata();
    }
  };

  // Rewind : 1er appui → reset chrono phase actuelle ; 2ème appui <2s → phase précédente
  const handleRewind=()=>{
    fired.current=false;
    const curPhaseDur=phaseRef.current==="work"?intvl.work:phaseRef.current==="rest"?intvl.rest:10;
    const now=Date.now();
    const timeLeft=Math.round((phaseEndRef.current-now)/1000);
    // Si on vient de resetter (phaseEndRef proche du max), ou si timeLeft > 2 → reset
    const justReset=rewindResetRef.current&&(now-rewindResetRef.current)<2500;
    if(!justReset&&timeLeft>2){
      // Chrono > 2s : retour au début de la phase actuelle
      rewindResetRef.current=now;
      phaseEndRef.current=now+curPhaseDur*1000;
      tRef.current=curPhaseDur;setT(curPhaseDur);
    } else {
      rewindResetRef.current=null;
      // Chrono <= 2s : phase précédente
      if(phaseRef.current==="work"){
        if(exI>0){
          // work[N] → rest[N-1] : décrémenter exI
          const prevEx=exI-1;setExI(prevEx);exIRef.current=prevEx;
          phaseRef.current="rest";setPhase("rest");
          phaseEndRef.current=Date.now()+intvl.rest*1000;
          tRef.current=intvl.rest;setT(intvl.rest);
          speak("Repos");
        } else if(round>0){
          // work[0] du round N → work[dernierEx] du round N-1
          phaseRef.current="work";setPhase("work");
          const prevEx=totalEx-1;setExI(prevEx);
          exIRef.current=prevEx;
          setRound(r=>r-1);
          roundRef.current=round-1;
          phaseEndRef.current=Date.now()+intvl.work*1000;
          tRef.current=intvl.work;setT(intvl.work);
          speak(exercises[prevEx]?.name||"Go");
        } else {
          // tout début : reset
          phaseEndRef.current=Date.now()+intvl.work*1000;
          tRef.current=intvl.work;setT(intvl.work);
        }
      } else if(phaseRef.current==="rest"){
        // rest[N-1] → work[N-1] : exI est déjà decrementé, inchangé ici
        phaseRef.current="work";setPhase("work");
        phaseEndRef.current=Date.now()+intvl.work*1000;
        tRef.current=intvl.work;setT(intvl.work);
        speak(exercises[exIRef.current]?.name||"Go");
      } else {
        // prepare : reset
        phaseEndRef.current=Date.now()+10*1000;
        tRef.current=10;setT(10);
      }
    }
  };

  // Skip : passe immédiatement à la phase suivante
  const handleSkip=()=>{
    fired.current=true;
    tRef.current=0;setT(0);
    setTimeout(()=>advance(exIRef.current,roundRef.current),100);
  };

  const elapsedMin=Math.max(1,Math.round((Date.now()-startTime)/60000));
  if(phase==="done")return(
    <div style={{position:"fixed",inset:0,background:C.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"0 24px"}}>
      
      <h2 style={{color:C.text,fontSize:28,fontWeight:900,margin:"0 0 8px",textAlign:"center"}}>TABATA TERMINÉ !</h2>
      <div style={{display:"flex",gap:20,marginBottom:36,justifyContent:"center",flexWrap:"wrap"}}>
        <div style={{textAlign:"center"}}><p style={{color:C.accent,fontSize:22,fontWeight:900,margin:"0 0 2px"}}>{rounds}</p><p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:0}}>ROUNDS</p></div>
        <div style={{textAlign:"center"}}><p style={{color:C.accent,fontSize:22,fontWeight:900,margin:"0 0 2px"}}>{totalEx}</p><p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:0}}>EXERCICES</p></div>
        <div style={{textAlign:"center"}}><p style={{color:C.accent,fontSize:22,fontWeight:900,margin:"0 0 2px"}}>{elapsedMin} min</p><p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:0}}>DURÉE</p></div>
      </div>
      <button onClick={onFinish} style={{background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:16,padding:"16px 40px",color:"white",fontWeight:800,fontSize:17,cursor:"pointer",boxShadow:`0 8px 28px ${C.glow}`}}>← Retour</button>
    </div>
  );

  const isWork=phase==="work";
  const isPrepare=phase==="prepare";
  const dur=isPrepare?10:isWork?intvl.work:intvl.rest;
  const pct=t/Math.max(dur,1);
  const col=t<=5?C.red:isWork?C.accent:C.green;
  const circ=2*Math.PI*72;
  const curExName=exercises[exI]?.name||"";
  // Calcul du prochain exercice : toujours exI+1 dans la progression normale
  const nextExI = exI + 1;
  const nextExName = nextExI < totalEx 
    ? exercises[nextExI]?.name 
    : (round + 1 < rounds ? exercises[0]?.name : null);

  return(
    <div style={{position:"fixed",inset:0,background:C.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",padding:"calc(env(safe-area-inset-top) + 20px) 24px 40px",boxSizing:"border-box"}}>
      <div style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{color:C.muted,fontSize:10,letterSpacing:3,margin:"0 0 2px"}}>{program.name}</p>
          <p style={{color:C.text,fontWeight:700,fontSize:13,margin:0}}>{isPrepare?"PRÉPARATION":`ROUND ${round+1}/${rounds}`}</p>
        </div>
        <button onClick={onFinish} style={{background:C.faint,border:"none",borderRadius:10,padding:"7px 13px",color:C.muted,fontWeight:700,fontSize:13,cursor:"pointer"}}>Arrêter</button>
      </div>

      <div style={{textAlign:"center",minHeight:72}}>
        <p style={{color:paused?C.muted:isPrepare?C.yellow:isWork?C.accent:C.green,fontSize:13,letterSpacing:4,fontWeight:800,margin:"0 0 4px"}}>
          {paused?"PAUSE":isPrepare?"PRÉPARE-TOI":isWork?"TRAVAIL":"REPOS"}
        </p>
        <p style={{color:C.muted,fontSize:11,margin:"0 0 4px",letterSpacing:2,visibility:!isWork&&!isPrepare&&nextExName?"visible":"hidden"}}>PROCHAIN EXERCICE</p>
        <h2 style={{color:C.text,fontSize:22,fontWeight:900,margin:0,textAlign:"center"}}>
          {isWork?curExName:(!isPrepare?nextExName:"\u00a0")||"\u00a0"}
        </h2>
      </div>

      <div style={{position:"relative",width:200,height:200}}>
        <svg width="200" height="200" style={{position:"absolute",top:0,left:0,transform:"rotate(-90deg)"}}>
          <circle cx="100" cy="100" r="72" fill="none" stroke={C.faint} strokeWidth="10"/>
          <circle cx="100" cy="100" r="72" fill="none" stroke={paused?C.muted:col} strokeWidth="10"
            strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={circ-pct*circ}
            style={{transition:"stroke-dashoffset 1s linear,stroke 0.3s"}}/>
        </svg>
        <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
          <span style={{color:paused?C.muted:t<=5?col:C.isDark?"white":C.text,fontSize:72,fontWeight:900,lineHeight:1,fontVariantNumeric:"tabular-nums"}}>{t}</span>
          <span style={{color:C.muted,fontSize:13}}>sec</span>
        </div>
      </div>

      <div style={{display:"flex",gap:10}}>
        {[5,4,3,2,1].map(n=><div key={n} style={{width:12,height:12,borderRadius:"50%",background:t>0&&t<=n?col:t===0?C.green:C.faint,transform:t>0&&t===n?"scale(1.5)":"scale(1)",transition:"all 0.2s"}}/>)}
      </div>

      <div style={{background:C.card,borderRadius:14,padding:"12px 20px",border:`1px solid ${C.border}`,textAlign:"center",width:"100%",boxSizing:"border-box"}}>
        {isPrepare
          ?<p style={{color:C.muted,fontSize:12,margin:0}}>Premier exercice : <span style={{color:C.text,fontWeight:700}}>{exercises[0]?.name}</span></p>
          :<p style={{color:C.text,fontSize:12,fontWeight:700,margin:0}}>Round {round+1} - Exercice {exI+1}/{totalEx}</p>
        }
      </div>

      <div style={{display:"flex",alignItems:"center",gap:18}}>
        {/* Bouton Retour */}
        <button onClick={handleRewind}
          style={{background:C.card,border:`1.5px solid ${C.border}`,borderRadius:50,width:58,height:58,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.15s",boxShadow:`0 2px 12px rgba(0,0,0,0.14)`,flexShrink:0}}
          onPointerDown={e=>{e.currentTarget.style.transform="scale(0.91)";e.currentTarget.style.background=C.faint;}}
          onPointerUp={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.background=C.card;}}
          onPointerLeave={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.background=C.card;}}>
          <svg width="26" height="26" viewBox="0 0 28 28" fill="none">
            {/* Barre verticale gauche */}
            <rect x="4" y="6" width="4" height="16" rx="2" fill={C.text} opacity="0.9"/>
            {/* Flèche gauche */}
            <path d="M22 7 L11 14 L22 21" stroke={C.text} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.9"/>
          </svg>
        </button>

        {/* Bouton Play/Pause central */}
        <button onClick={togglePause} style={{
          background:paused?`linear-gradient(145deg,${C.accent},${C.accent2})`:`linear-gradient(145deg,${C.card},${C.faint})`,
          border:`2.5px solid ${paused?C.accent:C.border}`,
          borderRadius:50,width:76,height:76,cursor:"pointer",
          display:"flex",alignItems:"center",justifyContent:"center",
          boxShadow:paused?`0 0 32px ${C.glow},0 6px 20px rgba(0,0,0,0.25)`:`0 4px 16px rgba(0,0,0,0.18)`,
          transition:"all 0.2s",flexShrink:0}}
          onPointerDown={e=>{e.currentTarget.style.transform="scale(0.93)";}}
          onPointerUp={e=>{e.currentTarget.style.transform="scale(1)";}}
          onPointerLeave={e=>{e.currentTarget.style.transform="scale(1)";}}>
          {paused
            ? /* PLAY icon – triangle arrondi */
              <svg width="30" height="30" viewBox="0 0 28 28" fill="none">
                <path d="M9 6.5 L22 14 L9 21.5 Z" fill="white" strokeLinejoin="round"/>
              </svg>
            : /* PAUSE icon – deux barres bien proportionnées */
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <rect x="6" y="6" width="5" height="16" rx="2.5" fill={C.text} opacity="0.9"/>
                <rect x="17" y="6" width="5" height="16" rx="2.5" fill={C.text} opacity="0.9"/>
              </svg>
          }
        </button>

        {/* Bouton Suivant */}
        <button onClick={handleSkip}
          style={{background:C.card,border:`1.5px solid ${C.border}`,borderRadius:50,width:58,height:58,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.15s",boxShadow:`0 2px 12px rgba(0,0,0,0.14)`,flexShrink:0}}
          onPointerDown={e=>{e.currentTarget.style.transform="scale(0.91)";e.currentTarget.style.background=C.faint;}}
          onPointerUp={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.background=C.card;}}
          onPointerLeave={e=>{e.currentTarget.style.transform="scale(1)";e.currentTarget.style.background=C.card;}}>
          <svg width="26" height="26" viewBox="0 0 28 28" fill="none">
            {/* Flèche droite */}
            <path d="M6 7 L17 14 L6 21" stroke={C.text} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.9"/>
            {/* Barre verticale droite */}
            <rect x="20" y="6" width="4" height="16" rx="2" fill={C.text} opacity="0.9"/>
          </svg>
        </button>
      </div>
    </div>
  );
}


// ─── TABATA PAGE (liste + lancement) ─────────────────────────────────────────
function TabataPage({tabatas,onCreateTabata,onGenerateTabata,onStartTabata,onEditTabata,onDeleteTabata,tutorialRefs,C}) {
  const BtnC=mkBtn(C);
  return(
    <div style={{position:"fixed",inset:0,background:C.bg,overflowY:"auto",padding:"calc(env(safe-area-inset-top) + 20px) 20px 110px",boxSizing:"border-box"}}>
      <div style={{padding:"0 0 22px"}}>
        <p style={{color:C.muted,fontSize:11,letterSpacing:3,margin:"0 0 5px"}}>ENTRAÎNEMENT CARDIO</p>
        <h1 style={{color:C.text,fontSize:26,fontWeight:900,margin:0}}>Tabatas</h1>
      </div>
      <div style={{background:`${C.accent}0A`,border:`1px solid ${C.accent}20`,borderRadius:14,padding:"12px 16px",marginBottom:20}}>
        <p style={{color:C.accent,fontSize:11,fontWeight:700,letterSpacing:2,margin:"0 0 4px"}}>COMMENT ÇA MARCHE</p>
        <p style={{color:C.muted,fontSize:13,margin:0,lineHeight:1.5}}>Choisis exercices, intervalle (travail/repos) et nombre de rounds. L'app chronomètre tout automatiquement avec guidance vocale.</p>
      </div>
      
      {/* Prominent Generate Tabata button */}
      <div ref={tutorialRefs?.generateTabata} style={{marginBottom:16,background:`linear-gradient(135deg,${C.accent},${C.accent2})`,borderRadius:16,padding:"18px 20px",cursor:"pointer",boxShadow:`0 4px 16px ${C.glow}`}} onClick={()=>onGenerateTabata()}>
        <p style={{color:"white",fontWeight:900,fontSize:16,margin:"0 0 4px"}}>Générer un Tabata</p>
        <p style={{color:"rgba(255,255,255,0.8)",fontSize:12,margin:0}}>Difficulté, durée, muscles — on s'occupe du reste</p>
      </div>
      
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <p style={{color:C.muted,fontSize:11,letterSpacing:3,margin:0}}>MES PROGRAMMES ({tabatas.length})</p>
        <div ref={tutorialRefs?.createTabata} style={{display:"inline-block"}}>
          <BtnC onClick={onCreateTabata} small>+ CRÉER</BtnC>
        </div>
      </div>
      {tabatas.length===0?(
        <p style={{color:C.muted,fontSize:14,textAlign:"center",lineHeight:1.6,marginTop:40}}>Aucun programme Tabata.<br/>Clique sur <strong style={{color:C.accent,fontWeight:700}}>Générer un Tabata</strong> ci-dessus pour créer automatiquement un programme, ou sur <strong style={{color:C.accent,fontWeight:700}}>Créer</strong> pour le créer manuellement.</p>
      ):(
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {tabatas.map(tab=>{
            const intvl=tab.interval==="custom"
              ?{work:tab.customWork||30,rest:tab.customRest||15}
              :INTERVALS.find(i=>i.id===tab.interval)||INTERVALS[0];
            const _work=typeof intvl.work==="number"?intvl.work:parseInt((tab.interval||"20").split("-")[0])||20;
            const _rest=typeof intvl.rest==="number"?intvl.rest:parseInt((tab.interval||"20-10").split("-")[1])||10;
            const _totalSec=10+tab.rounds*(tab.exercises.length*(_work+_rest));
            const _estMin=Math.ceil(_totalSec/60);
            return(
              <div key={tab.id} style={{background:C.card,borderRadius:18,padding:"16px",border:`1px solid ${C.border}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div style={{flex:1,minWidth:0}}>
                    <h3 style={{color:C.text,fontWeight:900,fontSize:16,margin:"0 0 4px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{tab.name}</h3>
                    <p style={{color:C.muted,fontSize:12,margin:"0 0 2px"}}>{tab.rounds} rounds · {tab.exercises.length} exercices · {intvl.label} · <span style={{color:C.accent,fontWeight:700}}>~{_estMin} min</span></p>
                  </div>
                  <div style={{display:"flex",gap:6,flexShrink:0}}>
                    <button onClick={()=>onEditTabata(tab)} style={{background:"none",border:"none",cursor:"pointer",padding:"4px",color:C.muted,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="3"/>
                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                      </svg>
                    </button>
                  </div>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:12}}>
                  {tab.exercises.slice(0,5).map((e,i)=>{const meta=MM[e.muscle]||{};return <span key={i} style={{background:meta.bg||C.faint,color:meta.color||C.muted,fontSize:11,padding:"3px 9px",borderRadius:12,fontWeight:600}}>{e.name}</span>;})}
                  {tab.exercises.length>5&&<span style={{background:C.faint,color:C.muted,fontSize:11,padding:"3px 9px",borderRadius:12}}>+{tab.exercises.length-5}</span>}
                </div>
                <button onClick={()=>onStartTabata(tab)} style={{width:"100%",padding:"12px",background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:15,cursor:"pointer",boxShadow:`0 4px 18px ${C.glow}`}}>LANCER</button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── CRÉER/MODIFIER TABATA ────────────────────────────────────────────────────
// ─── GENERATE TABATA PAGE ─────────────────────────────────────────────────
function GenerateTabataPage({onSave,onBack,C}) {
  const [difficulty,setDifficulty]=useState(null); // "easy"|"medium"|"hard"
  const [duration,setDuration]=useState(15); // minutes
  const [selectedMuscles,setSelectedMuscles]=useState([]);
  const [generatedTabata,setGeneratedTabata]=useState(null); // Pour la preview
  
  const difficulties=[
    {id:"easy",label:"Facile",work:30,rest:30,desc:"30-30s"},
    {id:"medium",label:"Moyen",work:40,rest:20,desc:"40-20s"},
    {id:"hard",label:"Difficile",work:50,rest:10,desc:"50-10s"},
  ];
  
  const muscleGroups=[
    {id:"Cardio / Full body",label:"Cardio / Full body",icon:"",color:MM["Cardio / Full body"].color,bg:MM["Cardio / Full body"].bg},
    {id:"Pectoraux",label:"Pectoraux",icon:"",color:MM["Pectoraux"].color,bg:MM["Pectoraux"].bg},
    {id:"Triceps",label:"Triceps",icon:"",color:MM["Triceps"].color,bg:MM["Triceps"].bg},
    {id:"Quadriceps",label:"Quadriceps",icon:"",color:MM["Quadriceps"].color,bg:MM["Quadriceps"].bg},
    {id:"Fessiers",label:"Fessiers",icon:"",color:MM["Fessiers"].color,bg:MM["Fessiers"].bg},
    {id:"Abdominaux",label:"Abdominaux",icon:"",color:MM["Abdominaux"].color,bg:MM["Abdominaux"].bg},
  ];
  
  const toggleMuscle=(id)=>setSelectedMuscles(p=>p.includes(id)?p.filter(m=>m!==id):[...p,id]);
  
  const canGenerate=difficulty&&selectedMuscles.length>0;
  
  const handleGenerate=()=>{
    if(!canGenerate)return;
    
    const diff=difficulties.find(d=>d.id===difficulty);
    const workTime=diff.work;
    const restTime=diff.rest;
    
    // Calculer nombre d'exercices pour utiliser TOUTE la durée
    // 1 exercice = workTime + restTime (ex: 30s+30s = 1min)
    const cycleTime=workTime+restTime;
    const totalSeconds=duration*60;
    const totalExercises=Math.floor(totalSeconds/cycleTime);
    
    // Stratégie rounds selon durée:
    // - Moins de 20min: 1 round (pas de répétition)
    // - 20-30min: 2 rounds max
    // - 35-45min: 3 rounds max
    let rounds, exercisesPerRound;
    
    if(duration < 20) {
      // Court: 1 round seulement
      rounds = 1;
      exercisesPerRound = totalExercises;
    } else if(duration <= 30) {
      // Moyen: 2 rounds max
      rounds = 2;
      exercisesPerRound = Math.ceil(totalExercises / 2);
    } else {
      // Long (35-45min): 3 rounds max
      rounds = 3;
      exercisesPerRound = Math.ceil(totalExercises / 3);
    }
    
    // Filtrer exercices selon muscles sélectionnés
    const availableEx=TABATA_EX_BASE.filter(ex=>selectedMuscles.includes(ex.muscle));
    
    if(availableEx.length===0){
      showToast("Aucun exercice disponible pour ces muscles", "error");
      return;
    }
    
    // Générer exercices en alternant les groupes musculaires, sans doublon si possible
    const generatedEx=[];
    // Pool initial : tous les exos disponibles, shufflés
    const shuffle=(arr)=>{const a=[...arr];for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;};
    let pool=shuffle(availableEx);
    const usedNames=new Set(); // noms déjà utilisés dans ce Tabata
    let lastExName=null;

    for(let i=0;i<exercisesPerRound;i++){
      const currentLastExName=lastExName;
      // Priorité 1 : exo pas encore utilisé ET pas même que le précédent
      let candidates=pool.filter(ex=>!usedNames.has(ex.name)&&ex.name!==currentLastExName);
      // Priorité 2 : si épuisé, reconstruire avec tous les exos sauf le précédent (on peut réutiliser)
      if(candidates.length===0){
        pool=shuffle(availableEx);
        usedNames.clear();
        candidates=pool.filter(ex=>ex.name!==currentLastExName);
      }
      // Priorité 3 : si toujours vide (1 seul exo disponible), accepter le même
      if(candidates.length===0) candidates=availableEx;

      const chosen=candidates[Math.floor(Math.random()*candidates.length)];
      usedNames.add(chosen.name);
      // Retirer du pool pour ne pas reproposer en priorité 1
      pool=pool.filter(ex=>ex.name!==chosen.name);
      generatedEx.push({...chosen});
      lastExName=chosen.name;
    }
    
    // Créer le programme - trouver l'intervalle correspondant dans INTERVALS si possible
    const matchedInterval=INTERVALS.find(i=>i.work===workTime&&i.rest===restTime&&i.id!=="custom");
    const tabata={
      id:Date.now(),
      name:`Tabata ${difficulty==="easy"?"Facile":difficulty==="medium"?"Moyen":"Difficile"} ${duration}min`,
      exercises:generatedEx,
      rounds,
      interval:matchedInterval?matchedInterval.id:"custom",
      customWork:matchedInterval?undefined:workTime,
      customRest:matchedInterval?undefined:restTime,
    };
    
    // Afficher la preview au lieu de sauvegarder directement
    setGeneratedTabata(tabata);
  };
  
  // PREVIEW du Tabata généré
  if(generatedTabata){
    return(
      <div style={{position:"fixed",inset:0,background:C.bg,padding:"calc(env(safe-area-inset-top) + 20px) 20px 100px",boxSizing:"border-box",display:"flex",flexDirection:"column",overflowY:"auto"}}>
        <div style={{padding:"0 0 16px",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setGeneratedTabata(null)} style={{background:"none",border:"none",color:C.muted,fontSize:24,cursor:"pointer",padding:0}}>←</button>
          <div>
            <h1 style={{color:C.text,fontSize:22,fontWeight:900,margin:0}}>Tabata généré</h1>
            <p style={{color:C.muted,fontSize:12,margin:"2px 0 0"}}>Valide ou recommence</p>
          </div>
        </div>
        
        <div style={{flex:1,overflowY:"auto",paddingBottom:20}}>
          {/* Infos du Tabata */}
          <div style={{background:C.card,borderRadius:14,padding:"16px",border:`1px solid ${C.border}`,marginBottom:16}}>
            <h2 style={{color:C.text,fontSize:18,fontWeight:900,margin:"0 0 8px"}}>{generatedTabata.name}</h2>
            <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
              <div style={{padding:"8px 12px",background:C.faint,borderRadius:8}}>
                <p style={{color:C.muted,fontSize:10,margin:0}}>ROUNDS</p>
                <p style={{color:C.accent,fontSize:18,fontWeight:900,margin:0}}>{generatedTabata.rounds}</p>
              </div>
              <div style={{padding:"8px 12px",background:C.faint,borderRadius:8}}>
                <p style={{color:C.muted,fontSize:10,margin:0}}>EXERCICES</p>
                <p style={{color:C.accent,fontSize:18,fontWeight:900,margin:0}}>{generatedTabata.exercises.length}</p>
              </div>
              <div style={{padding:"8px 12px",background:C.faint,borderRadius:8}}>
                <p style={{color:C.muted,fontSize:10,margin:0}}>INTERVALLE</p>
                <p style={{color:C.accent,fontSize:18,fontWeight:900,margin:0}}>{generatedTabata.customWork}-{generatedTabata.customRest}s</p>
              </div>
            </div>
          </div>
          
          {/* Liste des exercices */}
          <div style={{paddingBottom:100}}>
            <p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:"0 0 12px"}}>EXERCICES ({generatedTabata.exercises.length})</p>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {generatedTabata.exercises.map((ex,i)=>(
                <div key={i} style={{background:C.card,borderRadius:12,padding:"12px 14px",border:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:32,height:32,borderRadius:"50%",background:`${C.accent}15`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <span style={{color:C.accent,fontSize:14,fontWeight:900}}>{i+1}</span>
                  </div>
                  <div style={{flex:1}}>
                    <p style={{color:C.text,fontSize:14,fontWeight:700,margin:0}}>{ex.name}</p>
                    <p style={{color:C.muted,fontSize:11,margin:0}}>{ex.muscle}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Boutons d'action */}
        <div style={{position:"fixed",bottom:90,left:20,right:20,maxWidth:480,margin:"0 auto",display:"flex",gap:10}}>
          <button onClick={()=>setGeneratedTabata(null)}
            style={{flex:1,padding:14,background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.text,fontWeight:700,fontSize:14,cursor:"pointer"}}>
            Recommencer
          </button>
          <button onClick={()=>{onSave(generatedTabata);setGeneratedTabata(null);}}
            style={{flex:2,padding:14,background:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:14,cursor:"pointer",boxShadow:`0 4px 16px ${C.glow}`}}>
            Enregistrer & Lancer
          </button>
        </div>
      </div>
    );
  }
  
  return(
    <div style={{position:"fixed",inset:0,background:C.bg,padding:"calc(env(safe-area-inset-top) + 20px) 20px 100px",boxSizing:"border-box",display:"flex",flexDirection:"column",overflowY:"auto"}}>
      <div style={{padding:"0 0 16px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onBack} style={{background:"none",border:"none",color:C.muted,fontSize:24,cursor:"pointer",padding:0}}>←</button>
        <div>
          <h1 style={{color:C.text,fontSize:22,fontWeight:900,margin:0}}>Générer un Tabata</h1>
          <p style={{color:C.muted,fontSize:12,margin:"2px 0 0"}}>Configuration automatique</p>
        </div>
      </div>
      
      <div style={{flex:1,overflowY:"auto",paddingBottom:20}}>
        {/* Difficulté */}
        <div style={{marginBottom:16}}>
          <label style={{color:C.text,fontSize:13,fontWeight:700,display:"block",marginBottom:8}}>Difficulté</label>
          <div style={{display:"flex",gap:8,justifyContent:"space-between"}}>
            {difficulties.map(d=>(
              <button key={d.id} onClick={()=>setDifficulty(d.id)}
                style={{flex:1,padding:"12px 8px",borderRadius:12,border:`2px solid ${difficulty===d.id?C.accent:C.border}`,background:difficulty===d.id?`${C.accent}15`:C.faint,cursor:"pointer",transition:"all 0.15s",textAlign:"center"}}>
                <p style={{color:difficulty===d.id?C.accent:C.text,fontWeight:800,fontSize:13,margin:"0 0 2px"}}>{d.label}</p>
                <p style={{color:C.muted,fontSize:9,margin:0}}>{d.desc}</p>
              </button>
            ))}
          </div>
        </div>
        
        {/* Durée */}
        <div style={{marginBottom:16}}>
          <label style={{color:C.text,fontSize:13,fontWeight:700,display:"block",marginBottom:8}}>Durée</label>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <button onClick={()=>setDuration(d=>Math.max(5,d-5))}
              style={{width:40,height:40,borderRadius:10,border:`1px solid ${C.border}`,background:C.faint,color:C.text,fontSize:20,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
              −
            </button>
            <div style={{flex:1,textAlign:"center"}}>
              <p style={{color:C.accent,fontSize:32,fontWeight:900,margin:0}}>{duration}</p>
              <p style={{color:C.muted,fontSize:11,margin:0}}>minutes</p>
            </div>
            <button onClick={()=>setDuration(d=>Math.min(45,d+5))}
              style={{width:40,height:40,borderRadius:10,border:`1px solid ${C.border}`,background:C.faint,color:C.text,fontSize:20,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
              +
            </button>
          </div>
        </div>
        
        {/* Muscles */}
        <div style={{marginBottom:16}}>
          <label style={{color:C.text,fontSize:13,fontWeight:700,display:"block",marginBottom:8}}>Groupes musculaires</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(2, 1fr)",gap:8}}>
            {muscleGroups.map(mg=>{
              const isSelected=selectedMuscles.includes(mg.id);
              return(
              <button key={mg.id} onClick={()=>toggleMuscle(mg.id)}
                style={{padding:"12px 10px",borderRadius:11,border:`1px solid ${isSelected?mg.color:C.border}`,background:isSelected?mg.bg:C.faint,cursor:"pointer",transition:"all 0.15s",textAlign:"center"}}>
                <span style={{color:isSelected?mg.color:C.text,fontSize:12,fontWeight:700}}>{mg.label}</span>
            </button>
            );
          })}
        </div>
      </div>
    </div>
      
      <button onClick={handleGenerate} disabled={!canGenerate}
        style={{position:"fixed",bottom:90,left:20,right:20,maxWidth:480,margin:"0 auto",padding:16,background:canGenerate?`linear-gradient(135deg,${C.accent},${C.accent2})`:C.faint,border:"none",borderRadius:14,color:canGenerate?"white":C.muted,fontWeight:800,fontSize:15,cursor:canGenerate?"pointer":"default",boxShadow:canGenerate?`0 6px 20px ${C.glow}`:"none",transition:"all 0.2s"}}>
        Générer le Tabata
      </button>
    </div>
  );
}


function CreateTabataPage({onSave,onBack,editingTabata,onDelete,C}) {
  const isEdit=!!editingTabata;
  const [name,setName]=useState(editingTabata?.name||"");
  const [rounds,setRounds]=useState(editingTabata?.rounds||4);
  const [interval,setInterval]=useState(editingTabata?.interval||"20-10");
  const [customWork,setCustomWork]=useState(editingTabata?.customWork||30);
  const [customRest,setCustomRest]=useState(editingTabata?.customRest||15);
  const [exercises,setExercises]=useState(editingTabata?.exercises||[]);
  const [showPicker,setShowPicker]=useState(false);
  const [showDeleteConfirm,setShowDeleteConfirm]=useState(false);
  const [dragTabIdx,setDragTabIdx]=useState(null);
  const dragTabStartYRef=useRef(0);
  const dragTabRowHRef=useRef(55);
  const BtnC=mkBtn(C);
  const intvl=interval==="custom"
    ?{work:customWork,rest:customRest}
    :INTERVALS.find(i=>i.id===interval)||INTERVALS[0];
  const totalSec=exercises.length*(intvl.work+intvl.rest)*rounds;
  const addEx=ex=>{setExercises(p=>[...p,{...ex}]);setShowPicker(false);};
  const removeEx=i=>setExercises(p=>p.filter((_,j)=>j!==i));
  const save=()=>{
    if(!name.trim()||exercises.length===0)return;
    onSave({id:editingTabata?.id||Date.now(),name:name.trim(),rounds,interval,customWork:interval==="custom"?customWork:undefined,customRest:interval==="custom"?customRest:undefined,exercises});
  };
  return(
    <div style={{position:"fixed",inset:0,background:C.bg,display:"flex",flexDirection:"column",overflow:"hidden"}}>
      {showPicker&&<ExPicker onPick={addEx} onClose={()=>setShowPicker(false)} C={C} isTabata={true}/>}
      {showDeleteConfirm&&<ConfirmModal message={`Supprimer "${editingTabata?.name}" ?`} onConfirm={()=>{onDelete(editingTabata.id);}} onCancel={()=>setShowDeleteConfirm(false)} C={C}/>}
      <div style={{padding:"calc(env(safe-area-inset-top) + 20px) 20px 14px",background:C.surface,borderBottom:`1px solid ${C.border}`,flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
          <button onClick={onBack} style={{background:"none",border:"none",color:C.muted,fontSize:24,cursor:"pointer"}}>←</button>
          <h2 style={{color:C.text,fontSize:18,fontWeight:900,margin:0,flex:1}}>{isEdit?"MODIFIER":"CRÉER"} UN TABATA</h2>
          {isEdit&&<button onClick={()=>setShowDeleteConfirm(true)} style={{background:"none",border:"none",cursor:"pointer",padding:4,color:C.red,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
            </svg>
          </button>}
        </div>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="Nom du programme..."
          style={{width:"100%",background:C.faint,border:`1px solid ${C.border}`,borderRadius:12,color:C.text,fontSize:16,padding:"11px 13px",outline:"none",boxSizing:"border-box"}}/>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"16px 20px 110px"}}>
        {/* Intervalle */}
        <p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:"0 0 10px"}}>INTERVALLE</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:7,marginBottom:12}}>
          {INTERVALS.map(iv=>(
            <button key={iv.id} onClick={()=>setInterval(iv.id)} style={{padding:"8px 6px",borderRadius:12,border:`1px solid ${interval===iv.id?C.accent:C.border}`,background:interval===iv.id?`${C.accent}18`:C.faint,color:interval===iv.id?C.accent:C.muted,fontWeight:700,fontSize:13,cursor:"pointer",textAlign:"center"}}>{iv.label}</button>
          ))}
        </div>
        {interval==="custom"&&(
          <div style={{background:C.card,border:`1px solid ${C.accent}30`,borderRadius:14,padding:"14px 16px",marginBottom:16}}>
            {[{label:"TRAVAIL (secondes)",val:customWork,set:setCustomWork,min:5,max:180},{label:"REPOS (secondes)",val:customRest,set:setCustomRest,min:5,max:180}].map(({label,val,set,min,max})=>(
              <div key={label} style={{marginBottom:12}}>
                <p style={{color:C.muted,fontSize:10,letterSpacing:2,margin:"0 0 8px"}}>{label}</p>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <button onClick={()=>set(v=>Math.max(min,v-5))} style={{background:C.faint,border:"none",borderRadius:9,width:40,height:40,color:C.text,fontSize:20,cursor:"pointer",flexShrink:0}}>−</button>
                  <div style={{flex:1,textAlign:"center"}}>
                    <span style={{color:C.accent,fontSize:28,fontWeight:900}}>{val}</span>
                    <span style={{color:C.muted,fontSize:13,marginLeft:5}}>s</span>
                  </div>
                  <button onClick={()=>set(v=>Math.min(max,v+5))} style={{background:C.faint,border:"none",borderRadius:9,width:40,height:40,color:C.accent,fontSize:20,cursor:"pointer",flexShrink:0}}>+</button>
                </div>
              </div>
            ))}
          </div>
        )}
        {/* Rounds */}
        <p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:"0 0 10px"}}>ROUNDS</p>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
          <button onClick={()=>setRounds(p=>Math.max(1,p-1))} style={{background:C.faint,border:"none",borderRadius:10,width:44,height:44,color:C.text,fontSize:22,cursor:"pointer"}}>−</button>
          <span style={{color:C.text,fontSize:32,fontWeight:900,flex:1,textAlign:"center"}}>{rounds}</span>
          <button onClick={()=>setRounds(p=>p+1)} style={{background:C.faint,border:"none",borderRadius:10,width:44,height:44,color:C.accent,fontSize:22,cursor:"pointer"}}>+</button>
        </div>
        {/* Résumé durée */}
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"10px 14px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{color:C.muted,fontSize:13}}>Durée estimée</span>
          <span style={{color:C.accent,fontWeight:900,fontSize:16}}>{Math.ceil(totalSec/60)} min</span>
        </div>
        {/* Exercices */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <p style={{color:C.muted,fontSize:11,letterSpacing:2,margin:0}}>EXERCICES ({exercises.length})</p>
          <button onClick={()=>setShowPicker(true)} style={{background:`${C.accent}18`,border:`1px solid ${C.accent}33`,borderRadius:9,padding:"6px 12px",color:C.accent,fontSize:12,fontWeight:800,cursor:"pointer"}}>+ Ajouter</button>
        </div>
        {exercises.length===0?(
          <div onClick={()=>setShowPicker(true)} style={{background:C.card,border:`1px dashed ${C.border}`,borderRadius:14,padding:"28px",textAlign:"center",cursor:"pointer"}}>
            <p style={{color:C.muted,fontSize:14}}>Appuyez pour ajouter des exercices</p>
          </div>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {exercises.map((e,i)=>{const meta=MM[e.muscle]||{};return(
              <div key={i} data-tabdrag style={{background:dragTabIdx===i?`${C.accent}18`:C.card,border:`1px solid ${dragTabIdx===i?C.accent:C.border}`,borderRadius:12,padding:"11px 13px",display:"flex",alignItems:"center",gap:9,transition:"background 0.1s,border 0.1s"}}>
                <span style={{flexShrink:0,cursor:"grab",padding:"4px 8px",display:"flex",alignItems:"center",justifyContent:"center",touchAction:"none",userSelect:"none",lineHeight:1}}
                  onTouchStart={e2=>{
                    e2.stopPropagation();
                    const rect=e2.currentTarget.closest("[data-tabdrag]").getBoundingClientRect();
                    setDragTabIdx(i);
                    dragTabStartYRef.current=e2.touches[0].clientY;
                    dragTabRowHRef.current=rect.height+7;
                  }}
                  onTouchMove={e2=>{
                    e2.preventDefault();e2.stopPropagation();
                    const dy=e2.touches[0].clientY-dragTabStartYRef.current;
                    const newIdx=Math.max(0,Math.min(exercises.length-1,Math.round(i+dy/dragTabRowHRef.current)));
                    if(newIdx!==i){
                      setExercises(p=>{const a=[...p];const[m]=a.splice(i,1);a.splice(newIdx,0,m);return a;});
                      setDragTabIdx(newIdx);
                      dragTabStartYRef.current=e2.touches[0].clientY;
                    }
                  }}
                  onTouchEnd={()=>setDragTabIdx(null)}>
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none">
                    {[1,6,11].map(y=>(
                      <line key={y} x1="2" y1={y+1} x2="14" y2={y+1} stroke={C.muted} strokeWidth="1.8" strokeLinecap="round" opacity="0.6"/>
                    ))}
                  </svg>
                </span>
                <div style={{flex:1,minWidth:0}}>
                  <p style={{color:C.text,fontWeight:700,margin:"0 0 3px",fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</p>
                  <Tag label={e.muscle} color={meta.color||C.muted} bg={meta.bg||C.faint}/>
                </div>
                <button onClick={()=>removeEx(i)} style={{background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.2)",borderRadius:8,padding:"6px 10px",color:C.red,fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0}}>×</button>
              </div>
            );})}
          </div>
        )}
      </div>
      <div style={{position:"fixed",bottom:0,left:0,right:0,padding:"16px 20px 36px",background:C.surface,borderTop:`1px solid ${C.border}`}}>
        <button onClick={save} disabled={!name.trim()||exercises.length===0} style={{width:"100%",padding:"15px",background:(!name.trim()||exercises.length===0)?C.faint:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:14,color:(!name.trim()||exercises.length===0)?C.muted:"white",fontWeight:800,fontSize:16,cursor:(!name.trim()||exercises.length===0)?"default":"pointer",boxShadow:(!name.trim()||exercises.length===0)?"none":`0 6px 24px ${C.glow}`}}>
          {isEdit?"ENREGISTRER LES MODIFICATIONS":"CRÉER LE TABATA"}
        </button>
      </div>
    </div>
  );
}


export { TabataRunPage, TabataPage, GenerateTabataPage, CreateTabataPage };
